



























import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    "one-page-basket-item": () =>
      import(
        "@/components/app/global/baskets/basket/shared/onePageBasketItem.vue"
      )
  }
})
export default class OnePageBasketItems extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  // Props

  @Prop({ default: 0 })
  public limit!: number;

  // Variables

  public showAllProducts = false;

  // Computed

  public get basketProducts() {
    return this.$_.get(this.$basketData(), "basket.products", []);
  }

  public get visibleProducts() {
    if (!this.limit || this.showAllProducts) return this.basketProducts;
    return this.$_.slice(this.basketProducts, 0, this.limit);
  }

  public get showMoreButton() {
    return (
      !!this.limit &&
      !this.showAllProducts &&
      this.basketProducts.length > this.limit
    );
  }

  public get invisibleProductsCount() {
    return this.basketProducts.length - this.limit;
  }
}
